module.exports = __webpack_public_path__ + "media/images/left_arrow-5bd11f4685d4efdc326be3bd7d4e492f.png";